import { typeInputTyping } from '../../../common/datePicker/constants'
import InputSingleDate from '../../../common/datePicker/InputSingleDate'
import InputTypingDate from '../../../common/datePicker/InputTypingDate'
import { UseI18n } from '../../../common/hooks/useI18n'
import { Element } from '../../../common/html/element'
import { Icon } from '../../../common/html/icon'
import classes from './index.module.scss'

export const DateRangeCustom = ({
  onFromChange,
  onToChange,
  fromDate,
  toDate,
  placeholderTo,
  placeholderFrom,
}) => {
  return (
    <>
      <InputDate
        value={fromDate}
        onChange={onFromChange}
        maxDate={toDate}
        placeholder={placeholderFrom}
        defaultDate={fromDate ? new Date(fromDate) : undefined}
      />

      <InputDate
        value={toDate}
        onChange={onToChange}
        minDate={fromDate}
        placeholder={placeholderTo}
        defaultDate={toDate ? new Date(toDate) : undefined}
      />
    </>
  )
}

const InputDate = ({
  value,
  onChange,
  minDate,
  maxDate,
  placeholder,
  defaultDate,
}) => {
  const textPlaceholder = UseI18n(placeholder)
  return (
    <Element
      className={classes.date}
      style={{ backgroundColor: '#FFFFFF', borderRadius: 2 }}
    >
      <InputSingleDate
        defaultDate={defaultDate}
        onSubmit={onChange}
        minDate={minDate ? minDate : new Date(1950, 0, 1)}
        maxDate={maxDate ? maxDate : new Date(2050, 0, 0)}
      >
        <Element
          className={classes.input}
          style={{ borderColor: '#E0E0E0', borderRadius: 2 }}
        >
          <InputTypingDate
            date={value}
            onChange={onChange}
            typeInput={typeInputTyping.SINGLE_DATE}
            style={{ border: 'none', outline: 'none' }}
            placeholder={textPlaceholder}
            minDate={minDate ? minDate : new Date(1950, 0, 1)}
            maxDate={maxDate ? maxDate : new Date(2050, 0, 0)}
          />
          <Icon
            className="icon-calendar"
            style={{ fontSize: 16, color: '#9C9C9C' }}
          />
        </Element>
      </InputSingleDate>
    </Element>
  )
}
